module.exports = "<div class=\"wow-toolbar animated fadeInDown\" id=\"search-bar\">\r\n\t<div class=\"wow-toolbar_animation-container\">\r\n\t\t<wow-store-picker ng-if=\"!isMobileScreen\"></wow-store-picker>\r\n\r\n\t\t<bws-search-bar></bws-search-bar>\r\n\r\n\t\t<a ng-if=\"orderTracker.isEnabled\" href=\"javascript:void(0)\" class=\"wow-toolbar_toogle-order-tracker\"\r\n\t\t   ng-click=\"toogleOrderPanel()\">\r\n\t\t\t<i class=\"icon--bell wow-toolbar_toogle-order-tracker_icon animated tada\"></i>\r\n\t\t</a>\r\n\t</div>\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/toolbar/toolbar-template.html
 ** module id = 1038
 ** module chunks = 1
 **/